export const declineReasonsArr = [
  { id: 1, checked: false, reason: 'The Image is not appropirate' },
  { id: 2, checked: false, reason: 'The image is not clear' },
  { id: 3, checked: false, reason: 'lack of information ' },
  { id: 4, checked: false, reason: 'The price is overrated ' },
  { id: 5, checked: false, reason: 'Other ' },
]
